import React from 'react';
import ParentLayout from '../Layout';
import useRouter from '../../../hooks/useRouter';
import Offer from '../../offers/Offer';
import DateCreated from '../../offers/_fields/DateCreated';
import MissingFields from '../../offers/_fields/MissingFields';
import useQuery from './useQuery';
import CardChildrenWrapper from '../../_common_results/CardChildrenWrapper';

export default function Layout() {
  const { location } = useRouter();

  const PAGE_SIZE = 10;

  const result = useQuery({
    location,
    PAGE_SIZE
  });

  return (
    <ParentLayout
      breadcrumbs={['Explore', 'Offers']}
      title="Nearby Offers"
      description={(
        <span>
          These are offers created by users nearby schools in your network.
        </span>
      )}
      pageSize={PAGE_SIZE}
      result={result}
      row={function(offer) {
        return (
          <Offer key={offer.id} offer={offer}>
            <CardChildrenWrapper>
              <div className="grid grid-cols-2 gap-4 w-full">
                <DateCreated offer={offer} />
                <MissingFields offer={offer} />
              </div>
            </CardChildrenWrapper>
          </Offer>
        );
      }}
    />
  );
}
